<template>
  <v-container grid-list-xs fill-height>
    <v-img class="background" src="/img/background-blur.jpg" />
    <v-row no-gutters justify="center">
      <v-col cols="12" xs="12" sm="10" md="6" class="semiWhite"  style="position: relative;">
        <h1 class="mt-5 mb-10 text-center text-decoration-underline">Par équipes</h1>
        <v-timeline dense dark>
          <v-timeline-item v-for="(item, index) in sortedScores" :key="index" color="white" large fill-dot>
            <template v-slot:icon>
            <v-avatar><img class="podium-image" :src="getImagePosition(index)"></v-avatar>
            </template>
            <v-card class="elevation-2 mr-7">
              <v-card-title class="text-h5 justify-start">
                <span><strong>{{item.score}}</strong> - {{item.teamName}}</span>
              </v-card-title>
            </v-card>
          </v-timeline-item>
       </v-timeline>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
   import party from "party-js"

   /**
   * @brief Ranking view display team user quizz ranking (btob/btoc).
   * @bug No known bugs.
   */
  export default {
    name: 'Ranking',
    data: () => ({
      confettiTimer: [1000, 1500, 2000, 2500, 3000, 3500, 4000],
      scores:  [],
      user: JSON.parse(window.localStorage.getItem('sapio_user')),
    }),
    computed: {
      userName: function () {
        return this.user ? this.user.name : 'Mon équipe'
      },
      sortedScores: function () {
        return this.scores.sort((a,b) => b.score - a.score)
      },
    },
    mounted() {
      this.scores = [{teamName: this.userName, score: SAPIO.Game.instance.score}]
      this.confettiTimer.forEach(time => {
        setTimeout(() => {
            this.launchEndAnimation()
        }, time)
      });
    },
    methods: {
      goToGamePage() {
          this.$router.push({ path: '/game' })
      },
      launchEndAnimation() {
        party.confetti(this.$el, {
          count: party.variation.range(40, 60),
        });
      },
      getImagePosition(index) {
        return index === 0 ? "/img/1st.png" :  index === 1 ? "/img/2nd.png" : index === 2 ? "/img/3rd.png" : null
      }
    }
  }
</script>

<style scoped>
  .background {
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
  }

  .semiWhite {
    background-color: rgba(255, 255, 255, 0.8);
  }

  .podium-image {
    margin-top: 3px;
  }
</style>